import { createAsyncThunk } from '@reduxjs/toolkit';
import { getMessageTemplates } from 'services/smsConversations';

export const ThunkGetMessageTemplates = createAsyncThunk(
  'pod/getMessageTemplates',
  async (channelId?: number | undefined) => {
    const r = await getMessageTemplates(channelId);
    return r.data;
  },
);
